import React from 'react';
import { cn } from '@/lib/twUtils';

export interface MarqueeProps {
  /** Durata di un giro completo, in secondi */
  duration?: number;
  /** Ampiezza della sfumatura ai bordi */
  fade?: 'wide' | 'narrow';
  /** Scorre da sinistra a destra: per righe affiancate che non vanno in coro */
  reverse?: boolean;
  className?: string;
  /** Il contenuto viene duplicato: passare un solo set di elementi */
  children: React.ReactNode;
}

const fades = {
  wide: 'linear-gradient(90deg,transparent,#000 12%,#000 88%,transparent)',
  narrow: 'linear-gradient(90deg,transparent,#000 6%,#000 94%,transparent)',
};

/**
 * Scorrimento orizzontale continuo in CSS: il contenuto viene duplicato e la
 * traccia trasla del 50%, così il ciclo è invisibile. Con `prefers-reduced-motion`
 * l'animazione si ferma e il duplicato sparisce (vedi globals.css).
 */
const Marquee = ({
  duration = 40,
  fade = 'wide',
  reverse = false,
  className,
  children,
}: MarqueeProps) => (
  <div
    className={cn('ds-marquee overflow-hidden', className)}
    style={{ maskImage: fades[fade], WebkitMaskImage: fades[fade] }}
  >
    <div
      className="ds-marquee-track"
      style={{
        ['--ds-marquee-duration' as string]: `${duration}s`,
        animationDirection: reverse ? 'reverse' : undefined,
      }}
    >
      <div className="flex shrink-0">{children}</div>
      <div className="flex shrink-0" aria-hidden data-ds-marquee-clone>
        {children}
      </div>
    </div>
  </div>
);

export default Marquee;
